export default class DateTime {
  private date: Date;
  constructor(private dateTime: string | Date) {
    this.date = new Date(dateTime);
  }

  private invalidDateChecker(date: string): string {
    if (date === "Invalid Date") {
      return this.dateTime?.toString() || "";
    } else {
      return date;
    }
  }

  public getNumericShDate(): string {
    const date = this.date.toLocaleString("fa-IR", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    });
    return this.invalidDateChecker(date);
  }

  public getLongShDate(): string {
    const date = this.date.toLocaleString("fa-IR", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    return this.invalidDateChecker(date);
  }

  public getNumericMlDate(): string {
    const date = this.date.toLocaleString("en-US", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    });
    return this.invalidDateChecker(date);
  }

  public getLongMlDate(): string {
    const date = this.date.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    return this.invalidDateChecker(date);
  }

  public getNumericHjDate(): string {
    const date = new Date(this.dateTime);
    const formatDate = date.toLocaleString("ar-SA-u-nu-latn", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    });

    return this.invalidDateChecker(formatDate);
  }

  public getLongHjDate(): string {
    const date = new Date(this.dateTime);
    const formatDate = date.toLocaleString("ar-SA-u-nu-latn", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    return this.invalidDateChecker(formatDate);
  }

  public getShWeekDay(): string {
    const date = this.date.toLocaleString("fa-IR", {
      weekday: "long",
    });
    return this.invalidDateChecker(date);
  }

  public getShWeekDayFullDate(): string {
    const date = this.date.toLocaleString("fa-IR", {
      weekday: "long",
      year: "numeric",
      month: "numeric",
      day: "numeric",
    });
    return this.invalidDateChecker(date);
  }

  public getMlWeekDay(): string {
    const date = this.date.toLocaleString("en-US", {
      weekday: "long",
    });
    return this.invalidDateChecker(date);
  }

  public getHjWeekDay(): string {
    const date = this.date.toLocaleString("ar-SA-u-nu-latn", {
      weekday: "long",
    });
    return this.invalidDateChecker(date);
  }

  public getShDayFa(): string {
    const date = this.date.toLocaleString("fa-IR", {
      day: "numeric",
    });
    return this.invalidDateChecker(date);
  }

  public getShYearFa(): string {
    const date = this.date.toLocaleString("fa-IR-u-nu-latn", {
      year: "numeric",
    });
    return this.invalidDateChecker(date);
  }

  public getShMonthFa(): string {
    const date = this.date.toLocaleString("fa-IR", {
      month: "long",
    });
    return this.invalidDateChecker(date);
  }

  public getShMonthEn(): string {
    const date = this.date.toLocaleString("fa-IR-u-nu-latn", {
      month: "numeric",
    });
    return this.invalidDateChecker(date);
  }

  public getHjDayEn(): string {
    const date = new Date(this.dateTime);
    // date.setDate(date.getDate() - 2);
    const formatData = date.toLocaleString("ar-SA-u-nu-latn", {
      day: "2-digit",
    });
    return this.invalidDateChecker(formatData);
  }

  public getMlDayEn(): string {
    const date = this.date.toLocaleString("en-US", {
      day: "2-digit",
    });
    return this.invalidDateChecker(date);
  }

  public getShDayEn(): string {
    const date = this.date.toLocaleString("fa-IR-u-nu-latn", {
      day: "numeric",
    });
    return this.invalidDateChecker(date);
  }
}
